module.exports = __webpack_public_path__ + "img/arrow-down.e99fa96f.svg";